import { getSite } from '@/utils/path'
import { ClientFileType } from '@/enum'

export const requestedVideoFile = (entry, needSite = true) => {
  let url = `requests/get_client_file?userId=${entry.userId}&name=${entry.fileName}&timestamp=${entry.fileTimestamp.getTime()}&type=${entry.fileType}`
  if (needSite) {
    return `${getSite()}${url}`
  } else {
    return `/${url}`
  }
}

export const requestedLogFile = (entry, needSite = false) => {
  return `/requests/get_client_file?userId=${entry.userId}&name=${entry.fileName}&timestamp=${entry.fileTimestamp.getTime()}&type=${entry.fileType}`
}

const requestFilesMapping = {
  [ClientFileType.VIDEO]: requestedVideoFile,
  [ClientFileType.LOG]: requestedLogFile
}

export const requestFilesUrl = (entry) => {
  return requestFilesMapping[entry.fileType](entry, false)
}

export const prepareEnumSwitches = (_enum_) =>
  Object.values(_enum_).reduce((acc, element) => {
    acc[element] = true
    return acc
  }, {})

export const stripEnumSwitches = (switches) => Object.keys(Object.fromEntries(Object.entries(switches).filter(([k, v]) => v === true)))
